module.exports = __webpack_public_path__ + "img/icon_portrait_report_image_6.169bae28.png";